var _path, _path2, _path3, _path4, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 26.2839V29.7947C30.0002 30.6433 29.6578 31.4572 29.0484 32.0572C28.4389 32.6573 27.6123 32.9944 26.7503 32.9944H7.25088C6.38896 32.9944 5.56233 32.6573 4.95285 32.0572C4.34338 31.4572 4.00098 30.6433 4.00098 29.7947V26.2839H30.0002Z",
    fill: "#F2CA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5004 4.20276H26.7503C27.6123 4.20276 28.4389 4.53987 29.0484 5.13993C29.6578 5.73998 30.0002 6.55384 30.0002 7.40245V29.8003C30.0002 30.6489 29.6578 31.4627 29.0484 32.0628C28.4389 32.6628 27.6123 32.9999 26.7503 32.9999H7.25088C6.38896 32.9999 5.56233 32.6628 4.95285 32.0628C4.34338 31.4627 4.00098 30.6489 4.00098 29.8003V7.40245C4.00098 6.55384 4.34338 5.73998 4.95285 5.13993C5.56233 4.53987 6.38896 4.20276 7.25088 4.20276H10.5008",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8752 1H12.1254C11.228 1 10.5005 1.71627 10.5005 2.59984V5.79953C10.5005 6.6831 11.228 7.39938 12.1254 7.39938H21.8752C22.7726 7.39938 23.5001 6.6831 23.5001 5.79953V2.59984C23.5001 1.71627 22.7726 1 21.8752 1Z",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3467 18.3865L16.2966 20.46L20.4132 16.7277",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0013,
    cy: 18.5948,
    rx: 5.68734,
    ry: 5.59945,
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/Confirmed.d567289e3dd181290480b60f71160db7.svg";
export { ForwardRef as ReactComponent };